import React, { useEffect, useState } from 'react'
import { DatePicker } from '../../components/shared/DatePicker';
import { Form } from 'semantic-ui-react';
import RoomsDropDown from '../../components/shared/RoomsDropDown';
import { RoomExpenses, RoomExpenseType } from '../../api/services/next'
import { useTextResources } from '../../language';
import GridSearchTemplate from '../GridSearchTemplate';
import moment from 'moment'
import { useLoader } from '../../components/shared/utils';
import { onError, onSuccess } from '../../components/shared/messages';
import { GetRooms } from '../../api/services/pms';
import { Currencies } from '../../components/shared/currencies';
import { RowEditModal } from './RowEditModal';
import { dateFormat } from '../../components/shared/constants';



export const ExpensesManagementPage = () => {

    const text = useTextResources()
    const loader = useLoader()
    const [data, setData] = useState([])
    const [spec, setSpec] = useState([])
    const [rooms, setRooms] = useState([])
    const [expenseTypes, setExpenseTypes] = useState([])

    const sendRequest = (callback,dataArr,refreshData) =>{
        (async () => {
            try {
                loader(true)
                await callback(dataArr);
                onSuccess()
                if(refreshData){
                    var res= await RoomExpenses.GetRoomExpenses(spec);
                    setData(res);
                }
            } catch (error) {
                onError(error);
            } finally {
                loader(false);
            }
        })()
    }

    const addRow = (row) => {
        sendRequest(RoomExpenses.AddRoomExpenses,[row],true);
    }
    const updateRow = (row) => {
        row.CreateDate = moment(row.CreateDate);
        row.Date = moment(row.Date);
        sendRequest(RoomExpenses.UpdateRoomExpenses,[row],true);
    }

    const onUpdate = (added, changed, deleted, data, beforeDelete) => {
        data.forEach(element => {
            if (element["Name"] == undefined || element["Name"] == '')
                element["Name"] = expenseTypes.find(x => x.Id == element["RoomExpenseTypeId"])?.Name
        });
        if(deleted && deleted.length) {
            sendRequest(RoomExpenses.DeleteRoomExpenses,[beforeDelete[deleted[0]].Id]);
        }
    }

    useEffect(() => {
        (async () => {
            const data = await GetRooms({HotelID: window.user?.CurrentHotel?.Id});
            setRooms(data)
        })()
    }, [])

    useEffect(() => {
        if (spec) {
            (async () => {
                const data = await RoomExpenseType.GetRoomExpenseType({});
                setExpenseTypes(data)
            })()
        }
    }, [])

    const getRoomCellValue = ({RoomId}) =>{
        return rooms.find(x => x.Id == RoomId)?.Name || ''
    }

    const getExpenseTypeCellValue = ({RoomExpenseTypeId}) => {
        return expenseTypes.find(x => x.Id == RoomExpenseTypeId)?.Name || ''
    }

    const getCurrencyCellValue = ({CurrencyId}) =>{
        return Currencies?.[CurrencyId]?.name || ''
    }

    const getDateCellValue = (date) => {
        return moment(date).format(dateFormat) || ''
    }

    const gridOptions = {
        search: {
            title: text("ExpensesManagement"),
            fields: [
                <DatePicker
                    type="range"
                    label={`${text("FromDate")} - ${text("ToDate")}`}
                    name="FromToDates"
                    key="FromToDates"
                />,
                <Form.Field label={text('Room')} placeholder={text('All')} multiple control={RoomsDropDown} data={rooms} key="RoomIds" clearable />
            ],
            initial: {
                "FromToDates": moment().startOf('month').toDate(),
                "HotelId": window.user?.CurrentHotel?.Id
            },

            api: RoomExpenses.GetRoomExpenses,
            searchOnLoad: true
        },
        grid: {
            columns: [
                { name: 'RoomExpenseTypeId', title: text("Name"), getCellValue: getExpenseTypeCellValue },
                { name: 'Name', title: text("Description") },
                { name: 'RoomId', title: text("Room"), getCellValue: getRoomCellValue },
                { name: 'CurrencyAmount', title: text("Amount") },
                { name: 'CurrencyId', title: text("Currency"), getCellValue: getCurrencyCellValue },
                { name: 'Date', title: text("Date"), getCellValue: ({Date})=> getDateCellValue(Date) },
                { name: 'CreateDate', title: text("CreateDate"), getCellValue: ({CreateDate})=> getDateCellValue(CreateDate) },
            ],
            cacheId: 'ExpensesManagementPage',
            customOptions: {
                group: {},
                sort: {}
            },
            export: true,
            paging: true,
            editable: {
                allowAdd: true,
                allowDelete: true,
                modalEditor: {
                    modal: RowEditModal,
                    props: {
                        expenseTypes,
                        rooms,
                        updateRow: updateRow,
                        addRow: addRow
                    }
                }
            }
        }
    }

    return (
      <GridSearchTemplate
        options={gridOptions}
        onGridUpdate={onUpdate}
        onSearchChange={setSpec}
        onSearchComplete={(data) => {
          setData(data);
          return true;
        }}
        data={data}
      />
    );

}
